<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="pubs"
      :search="search"
      density="compact"
      items-per-page="-1"
      hide-default-footer
      :loading="loadingDatatables"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            class="mb-2 text-white mr-3"
            :prepend-icon="mdiFile"
            color="#ffb300"
            @click="openDialog"
            dark
          >
            {{ $t("admin.new-pub") }}
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.startDate="{ item }">
        <span>{{ new Date(item.startDate).toLocaleDateString() }}</span>
      </template>

      <template v-slot:item.endDate="{ item }">
        <span>{{ new Date(item.endDate).toLocaleDateString() }}</span>
      </template>

      <template v-slot:item.position="{ item }">
        <v-icon v-if="item.position == 1">{{ mdiArrowUpBold }}</v-icon>
        <v-icon v-else-if="item.position == 2">{{ mdiArrowDownBold }}</v-icon>
        <v-icon v-else>{{ mdiArrowUpDownBold }}</v-icon>
        <span>
          {{
            item.position == 1
              ? "En Haut"
              : item.position == 2
              ? "En Bas"
              : "Les Deux"
          }}
        </span>
      </template>

      <template v-slot:item.active="{ item }">
        <v-icon v-if="item.active" color="green">{{ mdiCheckCircle }}</v-icon>
        <v-icon v-else color="red">{{ mdiCloseCircle }}</v-icon>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <v-icon size="small" @click="deleteItem(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>
    </v-data-table>
    <add-edit-pubs
      :modelDialog="pubsDialog"
      @close="pubsDialog = false"
    ></add-edit-pubs>
  </v-container>
</template>

<script>
import {
  mdiPencil,
  mdiDelete,
  mdiMagnify,
  mdiFile,
  mdiAccountPlus,
  mdiCheckCircle,
  mdiCloseCircle,
  mdiArrowUpBold,
  mdiArrowDownBold,
  mdiArrowUpDownBold,
} from "@mdi/js";
import AddEditPubs from "./admin/AddEditPubs.vue";
import { mapState } from "vuex";

export default {
  name: "AddressAdmin",
  components: { AddEditPubs },
  data() {
    return {
      mdiAccountPlus,
      mdiMagnify,
      mdiPencil,
      mdiDelete,
      mdiFile,
      mdiCheckCircle,
      mdiCloseCircle,
      mdiArrowUpBold,
      mdiArrowDownBold,
      mdiArrowUpDownBold,
      dialog: false,
      dialogDelete: false,
      pubsDialog: false,
      search: "",
      itemsPerPage: 15,
      page: 1,
      headers: [
        { title: "Nom", key: "name" },
        { title: "Description", key: "description" },
        { title: "Position", key: "position" },
        { title: "Date de début", key: "startDate" },
        { title: "Date de fin", key: "endDate" },
        { title: "Active", key: "active" },
        { title: "Actions", key: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    ...mapState({
      pubs: (state) => state.pubs.items,
      loadingDatatables: (state) => state.loadingTables,
      editedId: (state) => state.pubs.editedId,
    }),
  },
  methods: {
    openDialog() {
      this.$store.commit("pubs/setEditedId", -1);
      this.$store.commit(
        "pubs/setEditedItem",
        Object.assign({}, this.$store.state.pubs.defaultItem)
      );
      this.pubsDialog = true;
    },
    editItem(item) {
      this.$store.commit("pubs/setEditedId", item.id);
      this.$store.commit("pubs/setEditedItem", Object.assign({}, item));
      this.pubsDialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("alert.delete.pub"))) {
        this.$store
          .dispatch("pubs/deleteItem", item.id)
          .then(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.success.pub-delete"),
              color: "success",
            });
          })
          .catch(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.pub-delete"),
              color: "error",
            });
          });
      }
    },
  },
};
</script>
